import { render, staticRenderFns } from "./Newexception.vue?vue&type=template&id=0d140dc3&scoped=true&"
import script from "./Newexception.vue?vue&type=script&lang=js&"
export * from "./Newexception.vue?vue&type=script&lang=js&"
import style0 from "./Newexception.vue?vue&type=style&index=0&id=0d140dc3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d140dc3",
  null
  
)

export default component.exports